import { IconProps } from './IconProps';

export const HandWithRing = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="22"
      height="29"
      viewBox="0 0 22 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2880_1122)">
        <path
          d="M10.459 27.0117C14.7754 27.0117 17.832 24.668 19.4336 20.1367L21.6992 13.7793C21.8359 13.3691 21.9043 12.9883 21.9043 12.627C21.9043 11.3574 20.9473 10.459 19.7168 10.459C18.877 10.459 18.1152 10.9668 17.7051 11.9531L16.7188 14.375C16.6992 14.4434 16.6602 14.4727 16.6113 14.4727C16.543 14.4727 16.5137 14.4238 16.5137 14.3555V3.85742C16.5137 2.43164 15.625 1.54297 14.3066 1.54297C13.7891 1.54297 13.3203 1.72852 12.9688 2.08008C12.832 0.810547 12.041 0 10.8105 0C9.60938 0 8.76953 0.839844 8.62305 2.06055C8.29102 1.71875 7.8418 1.54297 7.36328 1.54297C6.12305 1.54297 5.27344 2.42188 5.27344 3.78906V5.2832C4.94141 4.91211 4.42383 4.72656 3.89648 4.72656C2.64648 4.72656 1.77734 5.64453 1.77734 7.02148V17.7637C1.77734 23.623 5.32227 27.0117 10.459 27.0117ZM10.4102 25.5078C6.02539 25.5078 3.22266 22.7148 3.22266 17.6074V7.16797C3.22266 6.5625 3.58398 6.14258 4.16016 6.14258C4.72656 6.14258 5.13672 6.5625 5.13672 7.16797V13.5352C5.13672 13.9648 5.46875 14.2383 5.82031 14.2383C6.20117 14.2383 6.5332 13.9648 6.5332 13.5352V3.96484C6.5332 3.35938 6.88477 2.94922 7.46094 2.94922C8.03711 2.94922 8.44727 3.35938 8.44727 3.96484V12.8906C8.44727 13.3301 8.76953 13.5938 9.13086 13.5938C9.50195 13.5938 9.83398 13.3301 9.83398 12.8906V2.44141C9.83398 1.83594 10.2344 1.39648 10.8105 1.39648C11.3672 1.39648 11.748 1.83594 11.748 2.44141V7.67091V12.9004C11.748 13.291 12.0508 13.5938 12.4414 13.5938C12.832 13.5938 13.1445 13.291 13.1445 12.9004V3.96484C13.1445 3.35938 13.5449 2.94922 14.1211 2.94922C14.6875 2.94922 15.0586 3.35938 15.0586 3.96484V16.2891C15.0586 16.875 15.4199 17.2168 15.918 17.2168C16.3477 17.2168 16.6992 17.0215 16.9531 16.4453L18.7207 12.4219C18.9746 11.8164 19.4727 11.6016 19.9707 11.7871C20.498 11.9727 20.6641 12.4902 20.4199 13.1445L18.1055 19.6582C16.6309 23.7891 13.9453 25.5078 10.4102 25.5078Z"
          fill={props.fill ?? '#000000'}
        />
        <path
          d="M12.5 10.5H16"
          stroke={props.fill ?? '#000000'}
          stroke-width="1.5"
        />
        <path
          d="M6 9H9.5"
          stroke={props.fill ?? '#000000'}
          stroke-width="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2880_1122">
          <rect
            width="21.9043"
            height="28.1348"
            fill={props.fill ?? '#000000'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

